<template>
  <transition enter-active-class="slide-in-right" leave-active-class="slide-out-right">
    <div class="ol-map-timelines" v-show="timelines.length > 0">
      <div class="ol-map-timeline-button">
        <svg-icon @click.native="onLeftClick" icon-name="left-circle" icon-class="ol-map-timeline-icon"></svg-icon>
      </div>

      <div class="ol-map-timeline-main">
        <div class="ol-map-timeline" :class="{ active: item.id === current.id }" v-for="item in timelineList"
          :key="item.id" @click="onClick(item)">
          <img class="ol-map-timeline-layer"
            :src="baseUrl + item.thumb + '&bbox=114.75127009220071%2C34.74617749121797%2C114.80346428583373%2C34.788872741565285'"
            alt="图层缩略图">
          <div class="ol-map-timeline-date">{{ item.productTimeCn }}</div>
        </div>
      </div>

      <div class="ol-map-timeline-info">
        <span>共 {{ total }} 条</span>
        <span>{{ currentPage }} / {{ pages }} 页</span>
      </div>

      <div class="ol-map-timeline-button">
        <svg-icon @click.native="onRightClick" icon-name="right-circle" icon-class="ol-map-timeline-icon"></svg-icon>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OlTimeline',

  props: {
    // 时间轴
    // 数据结构：[{ id: 1, label: '2023-03-06', layer: require('@/assets/images/layer.png') }]
    timelines: {
      type: Array,
      required: true
    }
  },

  computed: {
    timelineList() {
      return this.timelines.slice((this.currentPage - 1) * this.pageSize, this.pageSize * this.currentPage)
    }
  },

  watch: {
    timelines(list) {
      this.currentPage = 1
      this.total = list.length
      this.pages = Math.ceil(this.total / this.pageSize)
      this.current = this.timelineList[0]
    }
  },

  data() {
    return {
      total: 0,
      pages: 0,
      pageSize: 3,
      currentPage: 1,
      current: {},
      baseUrl: process.env.VUE_APP_THUMB,

    }
  },

  created() {
    this.total = this.timelines.length
    this.pages = Math.ceil(this.total / this.pageSize)
    this.current = this.timelines[0]
  },

  methods: {
    onLeftClick() {
      this.currentPage--
      if (this.currentPage <= 1) {
        this.currentPage = 1
      }
    },

    onRightClick() {
      this.currentPage++
      if (this.currentPage >= this.pages) {
        this.currentPage = this.pages
      }
    },

    onClick(payload) {
      if (payload.id !== this.current.id) {
        this.current = payload
        this.$emit('change', payload)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ol-map-timelines {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
  display: flex;
  height: 140px;
  padding: 10px;
  border: 1px solid rgba(30, 124, 104, 1);
  border-radius: 4px;
  backdrop-filter: blur(4px);
  background-color: rgba(4, 54, 35, 0.8);
  box-shadow: 0px -4px 10px 0px rgba(146, 159, 168, 0.4);
  z-index: 2;
}

.ol-map-timeline-button {
  display: flex;
  align-items: center;
}

.ol-map-timeline-icon {
  font-size: 32px;
  color: rgb(90, 234, 173, 0.5);
  margin: 0;
  cursor: pointer;

  &:hover {
    color: rgb(90, 234, 173, 0.7);
  }
}

.ol-map-timeline-main {
  position: relative;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: space-between;
  margin-right: 10px;
}

.ol-map-timeline {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 96px;
  height: 96px;
  margin-left: 10px;
  border-radius: 2px;
  background-color: rgba(0, 36, 23, 0.8);
  cursor: pointer;

  &.active {
    background-color: rgb(0 220 212 / 20%) !important;

    .ol-map-timeline-date {
      color: rgba(90, 234, 173, 1);
    }
  }

  &:hover {
    background-color: rgba(5, 121, 82, 0.2);
  }
}

.ol-map-timeline-layer {
  width: 50px;
  height: 50px;
}

.ol-map-timeline-date {
  font-size: 12px;
  color: #fff;
  margin-top: 10px;
}

.ol-map-timeline-info {
  position: absolute;
  left: 50%;
  bottom: 8px;
  display: flex;
  justify-content: space-between;
  width: 80%;
  font-size: 12px;
  color: #fff;
  transform: translateX(-50%);
}
</style>
